import styled from "styled-components";

const TopBg = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 45rem;
  height: 256;
  background: linear-gradient(338deg, #fac780 0%, #f8932d 100%);
  border-bottom-right-radius: 24;
  border-bottom-left-radius: 24;
`;

export const TopBackground = () => {
  return (
    <TopBg
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        maxWidth: "45rem",
        height: 256,
        background: "linear-gradient(338deg, #FAC780 0%, #F8932D 100%)",
        borderBottomRightRadius: 24,
        borderBottomLeftRadius: 24,
      }}
    />
  );
};
